// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "8dfdaa5ff7fdf5c0c0ef711af226d0121aedf621/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};